import { createMuiTheme } from '@material-ui/core';

export const PRIMARY_BUTTON_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 2,
                color: '#FFFFFF!important',
                fontWeight: '500!important',
                minWidth: '7.500em!important',
                fontSize: '15px!important',
                backgroundColor: '#0194d3 !important',
                '&:hover': {
                    backgroundColor: '#177DB6 !important'
                },
                '&:disabled': {
                    opacity: '0.4!important',
                    backgroundColor: '#177DB6 !important',
                    color: '#FFFFFF!important'
                }
            }
        }
    }
});

export const PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                minWidth: '100px !important',
                color: '#0091ea !important',
                '&:disabled': {
                    color: '#0091ea75 !important'
                }
            }
        }
    }
});

export const PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                minWidth: '100px !important',
                color: '#515151 !important'
            }
        }
    }
});

export const PRIMARY_BUTTON_LIGHT_OUTLINE_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                letterSpacing: '1px',
                color: '#0091ea !important',
                border: '2px solid #0091ea !important',
                fontWeight: '500!important',
                '&:disabled': {
                    color: '#0091ea69 !important',
                    border: '2px solid #0091ea69 !important',
                    cursor: 'not-allowed'
                }
            }
        }
    }
});

export const PRIMARY_BUTTON_LIGHT_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 2,
                letterSpacing: '1px',
                color: '#ffffff!important',
                fontWeight: '500 !important',
                fontFamily: "'Open Sans', sans-serif",
                lineSpacing: 1,
                fontSize: '15px!important',
                backgroundColor: '#0194d3 !important',
                padding: '6px 22px !important',
                '&:hover': {
                    backgroundColor: '#177DB6 !important'
                },
                '&:disabled': {
                    opacity: '0.4!important',
                    backgroundColor: '#177DB6 !important',
                    color: '#FFFFFF!important'
                }
            }
        }
    }
});

export const PRIMARY_BUTTON_SMALL_LIGHT_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 2,
                color: '#ffffff!important',
                fontWeight: '500 !important',
                fontFamily: "'Open Sans', sans-serif",
                fontSize: '14px!important',
                backgroundColor: '#0194d3 !important',
                padding: '3px 15px !important',
                '&:hover': {
                    backgroundColor: '#177DB6 !important'
                },
                '&:disabled': {
                    opacity: '0.4!important',
                    backgroundColor: '#177DB6 !important',
                    color: '#FFFFFF!important'
                }
            }
        }
    }
});

export const PRIMARY_BUTTON_LIGHT_NEGATIVE_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 2,
                letterSpacing: '1px',
                color: '#5d5b5b !important',
                fontWeight: '500 !important',
                lineSpacing: 1,
                fontSize: '15px!important',
                padding: '6px 22px !important',
                '&:disabled': {
                    color: '#5d5b5b78 !important'
                }
            }
        }
    }
});

export const PRIMARY_BUTTON_LIGHT_TRANSPARENT_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 2,
                letterSpacing: '1px',
                fontFamily: "'Open Sans', sans-serif",
                color: '#ffffff !important',
                fontWeight: '500 !important',
                lineSpacing: 1,
                fontSize: '15px!important',
                padding: '6px 22px !important',
                '&:hover': {
                    backgroundColor: 'transparent !important'
                },
                '&:disabled': {
                    color: '#5d5b5b78 !important'
                }
            }
        }
    }
});

export const PRIMARY_BUTTON_GROUP_ICON_LIGHT_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 2,
                letterSpacing: '1px',
                color: '#ffffff!important',
                fontWeight: '400!important',
                lineSpacing: 1,
                fontSize: '15px!important',
                backgroundColor: '#0194d3 !important',
                padding: '7px 5px !important',
                minWidth: '30px !important',
                '&:hover': {
                    backgroundColor: '#177DB6 !important'
                },
                '&:disabled': {
                    opacity: '0.4!important',
                    backgroundColor: '#177DB6 !important',
                    color: '#FFFFFF!important'
                }
            }
        }
    }
});

export const SECONDARY_BUTTON_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 0,
                color: '#0194d3',
                fontWeight: '500',
                minWidth: '7.500em',
                fontSize: '15px',
                backgroundColor: 'none !important',
                '&:hover': {
                    backgroundColor: '#E2E2E7 !important'
                },
                '&:disabled': {
                    opacity: '0.4',
                    backgroundColor: 'none !important'
                }
            }
        }
    }
});

export const EXPANSION_PANEL_BUTTONS = createMuiTheme({
    overrides: {
        MuiExpansionPanelActions: {
            root: {
                padding: '8px 25px !important'
            }
        }
    }
});

export const PRIMARY_BUTTON_MODUS_WHITE_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                letterSpacing: '1px',
                color: '#252A2E !important',
                border: '1px solid #252A2E !important',
                fontWeight: '600 !important',
                fontFamily: 'Open Sans !important',
                fontSize: '14px',
                textTransform: 'none',
                padding: '6px 16px !important',
                borderRadius: '2px !important'
            }
        }
    }
});

export const PRIMARY_BUTTON_MODUS_BLUE_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                letterSpacing: '1px',
                color: '#FFFFFF !important',
                border: '1px solid #0063A3 !important',
                backgroundColor: '#0063A3 !important',
                fontWeight: '600 !important',
                fontFamily: 'Open Sans !important',
                fontSize: '14px',
                textTransform: 'none',
                padding: '6px 16px !important',
                borderRadius: '2px !important',
                '&:disabled': {
                    color: '#0091ea69 !important',
                    border: '2px solid #0091ea69 !important',
                    cursor: 'not-allowed'
                }
            }
        }
    }
});

export const MODUS_SUCCESS_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                backgroundColor: '#006638',
                borderRadius: 4,
                color: 'rgb(255, 255, 255)',
                fontSize: 16,
                fontWeight: 700,
                height: 28,
                margin: '0px 8px 0px 0px',
                padding: '6px 12px',
                textAlign: 'center',
                textTransform: 'none',
                '&:hover': {
                    backgroundColor: '#4ea646'
                }
            }
        }
    }
});

export const MODUS_DANGER_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                backgroundColor: '#da212c',
                borderRadius: 4,
                color: 'rgb(255, 255, 255)',
                fontSize: 16,
                fontWeight: 700,
                height: 28,
                margin: '0px 8px 0px 0px',
                padding: '6px 12px',
                textAlign: 'center',
                textTransform: 'none',
                '&:hover': {
                    backgroundColor: '#e86363'
                }
            }
        }
    }
});
